<template>
  <div class="qr-reader" v-if="!isInLineBrowser">
    <TitleBar :text="$t('QrReader.topic')" :showIconButton="false" @clickCloseButton="clickCloseButton" />
    <div class="body" v-if="util.getUserAgentMeta() !== 'iOS application'">
      <div class="alert-from-qrcode-stream" v-if="messageFromQrcodeStream !== ''">{{ messageFromQrcodeStream }}</div>
      <qrcode-stream class="qrcode-stream" @init="onInitQrcodeStream" @decode="onDecode" :paused="paused" :track="repaint" v-if="(util.getUserAgentMeta() !== 'Android application') || (util.getUserAgentMeta() === 'Android application' && isAllowCamera)"></qrcode-stream>
      <qrcode-capture class="qrcode-capture" @decode="onDecode" v-if="util.getUserAgentMeta() !== 'Android application'" />
      <qrcode-capture class="qrcode-capture" @decode="onDecode" :manageSelectFileByMyself="true" @clickQrFileButton="selectImageFileFromNative" v-if="util.getUserAgentMeta() === 'Android application'" />
      <div style="display: none;">
        <img ref="promptpaiIcon" :src="util.getImagePath('promptpai_icon@2x.png')" :srcset="util.getImageSet('promptpai_icon')">
      </div>
    </div>
    <div class="body" v-if="util.getUserAgentMeta() === 'iOS application'">
      <div class="alert-from-qrcode-stream half" v-if="messageFromQrcodeStream !== ''">{{ messageFromQrcodeStream }}</div>
      <div class="select-file-notice">
        <img :src="util.getImagePath('browse_img_white.png')" :srcset="util.getImageSet('browse_img_white')">
        {{ $t('QrReader.selectImageFile') }}
      </div>
    </div>
  </div>
</template>

<script>
import TitleBar from '@/components/TitleBar.vue'
import { scan } from '../misc/scanner.js'
import { imageDataFromUrl } from '../misc/image-data.js'
import CommonAPI from '../mixins/CommonAPI.vue'

export default {
  name: 'QrReader',
  components: {
    TitleBar
  },
  mixins: [ CommonAPI ],
  props: {
    isReadUser: {
      type: Boolean,
      default: true
    },
    isReadPlace: {
      type: Boolean,
      default: true
    },
    selectedPromptpaiId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      messageFromQrcodeStream: '',
      paused: false,
      isAllowCamera: false
    }
  },
  mounted () {
    var self = this
    var userAgent = self.util.getUserAgentMeta()

    if (userAgent === 'iOS application') {
      self.selectImageFileFromNative()
    }
    if (userAgent === 'Android application') {
      window.allowCamera = () => {
        console.log('allowCamera')
        self.isAllowCamera = true
        // self.$router.go(0)
      }
      window.blockCamera = () => {
        console.log('blockCamera')
      }
      window.location.href = 'https://native.cameraPermission'
    }
    if (self.isInLineBrowser) {
      self.scanCode()
    }
  },
  computed: {
    isInLineBrowser () {
      var self = this
      var userAgent = self.util.getUserAgentMeta()
      if (window.liff) {
        if (window.liff.scanCode && userAgent !== 'Android application' && userAgent !== 'iOS application' && process.env.NODE_ENV !== 'development') {
          return window.liff.isInClient()
        }
      }
      return false
    }
  },
  methods: {
    scanCode () {
      var self = this
      var userAgent = self.util.getUserAgentMeta()
      if (userAgent !== 'Android application' && userAgent !== 'iOS application' && process.env.NODE_ENV !== 'development') {
        window.liff.scanCode().then(result => {
          self.onDecode(result.value)
        })
      }
    },
    selectImageFileFromNative () {
      var self = this
      window.selectImageFile = (ref, base64List) => {
        for (var i = 0; i < base64List.length; i++) {
          base64List[i] = `data:image/png;base64,${base64List[i]}`
        }
        const resultPromises = self.processFile(base64List[0])
        self.onDetect(resultPromises, self.onDecode)
      }
      window.blockSelectImageFile = () => {
        console.log('blockSelectImageFile')
      }
      window.cancelSelectImageFile = () => {
        console.log('cancleSelectImageFile')
        self.$router.back()
      }
      if (self.selectedPromptpaiId !== '' && self.selectedPromptpaiId !== undefined) {
        window.location.href = `https://native.selectImageFile?ref=qrreader&multiple=0&ppid=${self.selectedPromptpaiId}`
      } else {
        window.location.href = 'https://native.selectImageFile?ref=qrreader&multiple=0'
      }
    },
    async processFile (url) {
      const imageData = await imageDataFromUrl(url)
      const scanResult = await scan(imageData)
      return { source: 'file', ...scanResult }
    },
    clickCloseButton () {
      var self = this
      self.$router.back()
    },
    async onInitQrcodeStream (promise) {
      var self = this
      // show loading indicator
      try {
        await promise
        // successfully initialized
        self.messageFromQrcodeStream = ''
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          // user denied camera access permisson
          self.messageFromQrcodeStream = `user denied camera access permisson`
        } else if (error.name === 'NotFoundError') {
          // no suitable camera device installed
          self.messageFromQrcodeStream = `no suitable camera device installed`
        } else if (error.name === 'NotSupportedError') {
          // page is not served over HTTPS (or localhost)
          self.messageFromQrcodeStream = `page is not served over HTTPS (or localhost)`
        } else if (error.name === 'NotReadableError') {
          // maybe camera is already in use
          self.messageFromQrcodeStream = `maybe camera is already in use`
        } else if (error.name === 'OverconstrainedError') {
          // passed constraints don't match any camera.
          // Did you requested the front camera although there is none?
          self.messageFromQrcodeStream = `passed constraints don't match any camera.`
        } else if (error.name === 'StreamApiNotSupportedError') {
          // browser seems to be lacking features
          self.messageFromQrcodeStream = `browser seems to be lacking features`
        }
      } finally {
        // hide loading indicator
      }
    },
    onDecode (decodedString) {
      var self = this
      var userAgent = self.util.getUserAgentMeta()
      var splitedString
      self.messageFromQrcodeStream = self.selectedPromptpaiId
      if (decodedString.indexOf(`${window.location.origin}/sendto/`) !== -1 && self.isReadUser) {
        self.paused = true
        window.gtag('event', 'scan_qr', {'event_category': 'engagement', 'event_label': `scan_user_qr`})
        splitedString = decodedString.split('/')
        self.$root.$emit('openModal', {
          name: 'SendPlaceForm',
          uid: splitedString[splitedString.length - 1],
          selectedPromptpaiId: self.selectedPromptpaiId
        })
      } else if (decodedString.indexOf(`${window.location.origin}/p/`) !== -1 && !self.isReadPlace) {
        if (self.isInLineBrowser) {
          alert(self.$t('QrReader.scanUserQr'))
          self.clickCloseButton()
        } else {
          self.messageFromQrcodeStream = self.$t('QrReader.scanUserQr')
          if (userAgent === 'iOS application') {
            self.selectImageFileFromNative()
          }
        }
      } else if (decodedString.indexOf(`${window.location.origin}/p/`) !== -1 && self.isReadPlace) {
        self.paused = true
        window.gtag('event', 'scan_qr', {'event_category': 'engagement', 'event_label': `scan_place_qr`})
        splitedString = decodedString.split('/')
        self.$router.push(`/p/${splitedString[splitedString.length - 1]}`)
        // self.$router.back()
      } else {
        if (self.isInLineBrowser) {
          alert(self.$t('QrReader.wrongQr'))
          self.clickCloseButton()
        } else {
          self.messageFromQrcodeStream = self.$t('QrReader.wrongQr')
          if (userAgent === 'iOS application') {
            self.selectImageFileFromNative()
          }
        }
      }
    },
    repaint (location, ctx) {
      var self = this
      if (!self.paused) {
        const {
          topLeftFinderPattern,
          topRightFinderPattern,
          bottomLeftFinderPattern
        } = location
        const pointArray = [
          topLeftFinderPattern,
          topRightFinderPattern,
          bottomLeftFinderPattern
        ]
        pointArray.forEach(({ x, y }) => {
          ctx.drawImage(self.$refs['promptpaiIcon'], x - 16, y - 16, 32, 32)
        })
      }
    }
  }
}
</script>

<style scoped>
  .qr-reader {
    height: fit-content;
    width: 320px;
    height: 480px;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    position: relative;
    overflow: hidden;
    margin-top: auto;
    margin-bottom: auto;
  }

  .body {
    height: 430px;
    padding: 0px;
    box-sizing: border-box;
    background: rgb(0, 0, 0);
    position: relative;
  }

  .select-file-notice {
    width: 100%;
    height: 100%;
    background-color: rgb(0, 0, 0);
    color: rgb(255, 255, 255);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 16px;
    box-sizing: border-box;
    text-align: center;
    line-height: 1.75;
  }

  .select-file-notice > img {
    width: 24px;
    height: 24px;
    margin: 8px;
  }

  .alert-from-qrcode-stream {
    position: absolute;
    z-index: 5;
    color: rgb(255, 255, 255);
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .alert-from-qrcode-stream.half {
    height: 50%;
  }

  .qrcode-stream {
    width: 100%;
    height: 100%;
    background-color: rgb(0, 0, 0);
  }

  .qrcode-capture {
    position: absolute;
    bottom: 8px;
    right: 8px;
    width: 32px;
    height: 32px;
    z-index: 10;
  }

  @media only screen and (max-width: 768px) {
    .qr-reader {
      width: 100%;
      min-width: 320px;
      height: 100%;
      border-radius: 0px;
    }

    .body {
      height: calc(100% - 50px);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/QrReader.vue